<template>
  <fragment>
    <app-header :title="'Screen - ' + screen.name">
      <template #actions>
        <portal-target name="screen-actions"/>
      </template>
    </app-header>

    <c-horizontal-nav>
      <c-horizontal-nav-link :to="{ name: 'screens.single' }" exact>
        Overview
      </c-horizontal-nav-link>
      <c-horizontal-nav-link :to="{ name: 'screens.single.image-history' }" exact>
        Image History
      </c-horizontal-nav-link>
      <c-horizontal-nav-link v-if="!screen.is_manual" :to="{ name: 'screens.single.faults' }" exact>
        Fault History
      </c-horizontal-nav-link>
      <c-horizontal-nav-link v-if="!screen.is_manual" :to="{ name: 'screens.single.status-logs' }" exact>
        Online/Offline History
      </c-horizontal-nav-link>
      <c-horizontal-nav-link v-if="!screen.is_manual" :to="{ name: 'screens.single.brightness-logs' }" exact>
        Brightness Logs
      </c-horizontal-nav-link>
      <c-horizontal-nav-link
        v-if="isNavVisible('power_consumption') &&  screen.power_consumption_logs > 0"
        :to="{ name: 'screens.single.power-consumption' }"
      >
        Power Consumption
      </c-horizontal-nav-link>
       <c-horizontal-nav-link v-if="$can('read cameras')" :to="{ name: 'screens.single.camera-settings' }">
        Camera Settings
      </c-horizontal-nav-link>
      <c-horizontal-nav-link v-if="isNavVisible('attachments')" :to="{ name: 'screens.single.attachments' }" exact>
        Attachments
      </c-horizontal-nav-link>
    </c-horizontal-nav>

    <router-view v-if="screen.id" />
  </fragment>
</template>

<script>
import { toast } from '@chameleon/chameleon-vue'
import { helperComputed, helperMethods } from '@/vuex/modules/screens'

export default {
  props: {
    screenId: {
      type: Number,
      required: true
    }
  },

  async created () {
    try {
      await this.getScreen(this.screenId)
    } catch (error) {
      toast('Could not find the screen.', 'info')

      this.$router.replace({ name: 'screens' })
    }
  },

  computed: {
    ...helperComputed
  },

  methods: {
    ...helperMethods,

    isNavVisible (key) {
      if (!this.$user?.media_owner?.disabled_features || !Array.isArray(this.$user?.media_owner?.disabled_features)) {
        return true
      }

      return this.$user.media_owner.disabled_features.indexOf(key) === -1
    }
  }
}
</script>
